// MediaSelection.js
import React, { useEffect, useState } from "react";
import Tabs from "../../../Tabs";
import Upload from "../../Shared/UploadMedia";
import MediaBrowser from "../MediaBrowser";
import EmbedURL from "../../Shared/EmbedURL";
import EmbedCode from "../EmbedCode";
import RecentMedia from "../RecentMedia";

const MediaSelection = ({
  src,
  handleChange,
  handleTitle,
  type,
  defaultEmbedValue,
  categories = ["Upload", "Embed URL", "Browse", "Recent"],
  isBussinessBox = false,
  media,
  setMedia,
  isGifAllowed = false,
  showRecentDropdown = true,
  showEmbedDisclaimer = false,
  onEmbedURLChange = null,
}) => {
  const [selectedCategory, setSelectedCategory] = useState(categories[0]);

  const handleCategoryChange = (event, newValue) => {
    event.stopPropagation();
    setSelectedCategory(newValue);
  };

  return (
    <>
      {categories?.length > 0 && (
        <Tabs
          categories={categories}
          selectedCategory={selectedCategory}
          onCategoryChange={handleCategoryChange}
        />
      )}
      {(selectedCategory === categories[0] || categories?.length === 0) && (
        <Upload
          src={src}
          handleMedia={(files) => handleChange(type, files)}
          handleTitle={handleTitle}
          type={type}
          isBusinessBox={isBussinessBox}
          media={media}
          setMedia={setMedia}
        />
      )}
      {selectedCategory === categories[1] &&
        type !== "audio" &&
        categories?.length > 1 && (
          <EmbedURL
            defaultValue={defaultEmbedValue}
            type={type}
            onConfirm={(value) => handleChange(type, value)}
            pathType={isBussinessBox ? "bussinessBox" : "wheel"}
            media={media}
            showDisclaimer={showEmbedDisclaimer}
            onExternalChange={
              isBussinessBox ? (value) => onEmbedURLChange(value) : null
            }
          />
        )}
      {selectedCategory === categories[1] && type === "audio" && (
        <EmbedCode
          onConfirm={(value) => handleChange(type, value)}
          media={media}
        />
      )}
      {selectedCategory === "Browse" && (
        <MediaBrowser
          mediaType={type}
          onConfirm={(value) => handleChange(type, value)}
          isGifAllowed={isGifAllowed}
        />
      )}
      {selectedCategory === "Recent" && (
        <RecentMedia
          type={type}
          onClickMedia={(value) => handleChange(type, value)}
          showDropdown={showRecentDropdown}
        />
      )}
    </>
  );
};

export default MediaSelection;
